import { DownloadOutlined } from '@ant-design/icons';
import { Drawer } from '@framework/ui/components/drawer/Drawer.tsx';
import { Button, Space } from 'antd';
import { linkFileToDownload } from '../../utils/download/linkFileToDownload.ts';
import { useDocumentsInlineViewerContext } from './DocumentsInlineViewerContext.tsx';

export interface IDocumentsInlineViewerDrawerProps {}

export function DocumentsInlineViewerDrawer(
  props: IDocumentsInlineViewerDrawerProps,
) {
  const { currentDocument, handleResetCurrentDocument } =
    useDocumentsInlineViewerContext();

  if (!currentDocument) return null;

  return (
    <Drawer
      title={
        <Space>
          {currentDocument.name}
          <Button
            size="large"
            type="text"
            aria-label={`Scarica documento ${currentDocument.name}`}
            onClick={() => {
              linkFileToDownload({
                fileBlobUrl: currentDocument.url,
                filename: currentDocument.name,
                mimetype: currentDocument.mimetype,
              });
            }}
            icon={<DownloadOutlined aria-hidden={true} />}
          />
        </Space>
      }
      open={!!currentDocument}
      onClose={handleResetCurrentDocument}
      size="large"
      styles={{ body: { padding: 0 } }}
    >
      <iframe
        title={currentDocument.name}
        style={{ borderWidth: 0 }}
        src={`${currentDocument?.url}#navpanes=0&toolbar=1`}
        allowFullScreen
        width="100%"
        height="100%"
      />
    </Drawer>
  );
}
